"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Settings {
}
exports.default = Settings;
//# sourceMappingURL=Settings.js.map